import type { LeaveRequest, LeaveRequestPayload } from "./Izintypes";
export interface MockSubmitLeaveResult {
  status: number;
  message: string;
}

export async function mockSubmitLeaveRequest(
  formData: FormData
): Promise<MockSubmitLeaveResult> {
  let apiUrl = process.env.REACT_APP_API_URL + "/bawaslu_phwt/absensi/post/izin";
  const requestOptions = {
    method: "POST",
    body: formData,
    redirect: "follow" as RequestRedirect
  };

  let result = await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => { return { status: 400, message: "Gagal mengirim pengajuan. Silakan coba lagi.", error : error.message } });

  return result;
}

export function buildLeaveFormData(payload: LeaveRequestPayload): FormData {
  const formData = new FormData();
  formData.append("id_karyawan", String(payload.idKaryawan));
  formData.append("type", payload.type);
  formData.append("start_date", payload.startDate);
  formData.append("end_date", payload.endDate);
  formData.append("keterangan", payload.keterangan);
  formData.append("status", "pending");
  formData.append("submitted_at", new Date().toISOString());
  if (payload.attachment) { formData.append("attachment", payload.attachment); } else { formData.append("attachment", ""); }
  return formData;
}

/** Seed data so the list isn't empty on first load. */
export async function getSeedLeaveRequests(id_karyawan : string): Promise<LeaveRequest[]> {
    let apiUrl = process.env.REACT_APP_API_URL + "/bawaslu_phwt/absensi/izin/" + id_karyawan;

    const requestOptions = {
        method: "GET",
        redirect: "follow" as RequestRedirect
    };

    const result = await fetch(apiUrl, requestOptions)
        .then((response) => response.json())
        .then((result) => result)
        .catch((error) => { return { status : 500, message : "Error Saat fetch Ambil data izin", error : error.getMessage() } } );
    
    const data = result.data.map((row : any) => {
        return { ...row, idKaryawan : parseInt(id_karyawan) };
    })

    if(result.status == 200) return data;
    else alert("Status : " + result.status + ", Pesan :" + result.message ); return [];
}